export default __webpack_public_path__ + "static/media/team_01.4e1bd66f.png";